import type { OnboardingApiOptions } from '@finnest/power-admin-client';
import { resolvePowerAdminApiBaseUrl } from '../runtime/power-admin-api.ts';

export const onboardingApiOptions = (): OnboardingApiOptions => ({
  apiBaseUrl: resolvePowerAdminApiBaseUrl(),
  requestInit: { credentials: 'include' },
});
